import { forwardRef, ComponentPropsWithoutRef, ReactNode } from "react";

export type TableCellProps = {
  /** Optional extra class(es) */
  className?: string;
  children: ReactNode;
} & ComponentPropsWithoutRef<"td">;

const TableCell = forwardRef<HTMLTableCellElement, TableCellProps>(
  ({ children, ...rest }, ref) => (
    <td ref={ref} {...rest}>
      {children}
    </td>
  )
);

TableCell.displayName = "TableCell";

export default TableCell;
